import styled from 'styled-components';
import { useCases } from '@/hooks';
import { pendingCases } from '../filterCases';
import { COUNCIL_KEEP } from '../tones';

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
`;
const Title = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.xl};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const Tagline = styled.p`
  margin: 4px 0 0;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
  max-width: 60ch;
`;
const Chips = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
`;
const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  background: ${({ theme }) => theme.color.glassBg};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;
const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${COUNCIL_KEEP};
`;

export function CouncilHeader() {
  const { cases } = useCases();
  const active = pendingCases(cases).length;
  return (
    <Header>
      <div>
        <Title>Council of Moderators</Title>
        <Tagline>
          Moderating against threats, terrorism, scams, fraud, and coordinated abuse. Protecting
          free speech.
        </Tagline>
      </div>
      <Chips>
        <Chip>
          <Dot /> Live Queue
        </Chip>
        <Chip>{active} Active Cases</Chip>
      </Chips>
    </Header>
  );
}
